import isISO8601 from 'validator/lib/isISO8601';

export const validatorsMapping = {
  string: 'isString',
  decimal: '',
  integer: 'isNumber',
  boolean: '',
  uuid: '',
  date: (err) => (v) => isISO8601(v) ? undefined : [err],
  time: '',
  datetime: '',
  email: 'isValidEmail',
  iban: 'isValidIBAN',
  licensePlateNld: '',
  postalcodeNld: 'isValidPostalCode',
  phoneNumber: 'isNumber',
  vehicleIdentificationNumber: '',
  vehicleCheckCode: '',
  zonedDateTime: '',
  phone: 'isPhoneNumber',
  mobilephone: 'isPhoneNumber',
  zorgwebValidator: 'zorgwebValidator',
};

export default validatorsMapping;
